// Types
import type { TModalProps } from './Modal.type';

export const MODAL_DEFAULT_PROPS: TModalProps = {
	isOpen: false,
}
